<template>
  <div class="listItem">
    <div class="header">
      <div class="left">
        <div class="title">
          <b>{{ data.leftTitle }}</b>
        </div>
        <div class="time">{{ data.leftSubTitle }}{{ data.time | formatTime }}</div>
      </div>
      <div class="right">
        <div class="right-title" :class="'status' + data.status">{{ data.rightTitle }}</div>
        <div class="right-content" v-if="data.rightContent">{{ data.rightContent }}</div>
      </div>
    </div>
    <div class="product-card" v-if="!!data.productInfo" @click="toProductDetial">
      <div class="image">
        <z-image lazy-load fit="cover" class="cover-image" :src="data.productInfo.pic" />
      </div>
      <div class="info">
        <div class="title">{{ data.productInfo.title }}</div>
        <div class="price">{{ data.productInfo.price }}</div>
      </div>
      <div class="arrow"><z-icon name="arrow" size="16px" color="#999999" /></div>
    </div>
    <div class="content">{{ data.content }}</div>
    <div class="actionList">
      <z-button
        class="button"
        v-for="buttonItem in data.actionList"
        :key="buttonItem.text"
        :type="+buttonItem.type === 1 ? 'primary' : 'default'"
        size="small"
        @click="goto(buttonItem.linkUrl, buttonItem.title, buttonItem.btnType)"
      >
        {{ buttonItem.title }}
      </z-button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import native from '@zz-common/native-adapter'
import { Button, Icon, Image, Lazyload, Dialog, Toast } from '@zz-common/zz-ui'
import { lego } from '@zz-common/lego'
import { deleteproduct, cancellimit, safeCenterButtonCheck } from '../../../../api/resourceApi'
Vue.use(Lazyload)
export default {
  name: 'SpamCard',
  props: {
    data: Object,
    active: Number,
    onLoad: Function
  },
  data() {
    return {
      cansubmit: true
    }
  },
  filters: {
    formatTime(timeStamp) {
      return timeStamp ? new Date(Number(timeStamp)).format('YYYY-MM-DD HH:mm') : ''
    }
  },
  components: {
    zButton: Button,
    zIcon: Icon,
    zImage: Image
  },
  methods: {
    goto(link, title, btnType = '1') {
      console.log('link', link)
      //btnType 1 跳转页面  2 删除商品  3 解除限制
      if (title == '重新上架') {
        this.handleButtonClick(link)
        return
      }
      if (btnType === '1') this.toPage(link)
      if (btnType === '2') this.deletePro()
      if (btnType === '3') this.unfreeze()
      lego.send({
        pagetype: 'ZZUP_SAFECENTER_DETIAL',
        actiontype: 'APPEAL_CLICK',
        backup: { link, title }
      })
    },
    async handleButtonClick(link) {
      try {
        // 获取商品ID
        const infoid = this.data.productInfo?.infoId || ''
        // 调用接口
        const res = await safeCenterButtonCheck({
          infoid
        })
        const { status, message } = res || {}
        // 处理返回结果
        if (status == 1) {
          this.toPage(link)
        }
        if (status == 0) {
          Toast(message)
        }
      } catch (error) {
        console.error('校验调用失败:', error)
      }
    },
    async deletePro() {
      deleteproduct({
        identity: 2,
        infoId: this.data.productInfo.infoId,
        fromdel: 'spamdel'
      })
        .then(async(res) => {
          const { desc, windowPop = {} } = res
          const { title, content, bottom } = windowPop
          if (desc) {
            await Toast.success({
              duration: 1500,
              message: desc || '删除成功'
            })
            await this.$emit('onRefresh')
          } else if (title) {
            Dialog({
              title,
              message: content,
              confirmButtonText: bottom,
              closeOnClickOverlay: true
            }).then(() => {
              this.$emit('onRefresh')
            })
          }
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
        })
      // const res = await deleteproduct({
      //   identity: 2,
      //   infoId: this.data.productInfo.infoId,
      //   fromdel: 'spamdel'
      // })
      // const { desc, windowPop = {} } = res
      // const { title, content, bottom } = windowPop
      // if (desc) {
      //   await Toast.success({
      //     duration: 1500,
      //     message: desc || '删除成功'
      //   })
      //   await this.$emit('onRefresh')
      // } else if (title) {
      //   Dialog({
      //     title,
      //     message: content,
      //     confirmButtonText: bottom,
      //     closeOnClickOverlay: true
      //   }).then(() => {
      //     this.$emit('onRefresh')
      //   })
      // }
    },
    async unfreeze() {
      await cancellimit()
      Toast.success('已取消限制')
      // this.$parent.onRefresh()
      this.$emit('onRefresh')
    },
    toPage(link) {
      if (!link) return ''
      native.skipToUrl({
        targetUrl: link,
        needClose: 0
      })
    },
    toProductDetial() {
      console.log('active', this.active)
      if (this.active === 2) {
        native.wrap('enterDetail')({
          infoId: this.data.productInfo.infoId,
          from: 'm'
        })
      } else if (this.active === 3) {
        native.wrap('enterOrderDetail')({
          orderId: this.data.productInfo.orderId,
          from: 'm'
        })
      }
    }
  },
  mounted() {
    console.log('active', this.active)
  }
}
</script>
<style scoped lang="less">
  @import 'index.less';
</style>
